export function StarRating({
  rating,
  count,
  inverted = false,
}: {
  rating: number;
  count?: number;
  /** Light text for dark backgrounds (e.g. store header) */
  inverted?: boolean;
}) {
  return (
    <div className="flex flex-wrap items-center gap-1 text-xs">
      <span className="text-amber-400" aria-hidden>
        ★
      </span>
      <span
        className={
          inverted ? 'font-semibold text-white' : 'font-semibold text-slate-800 dark:text-slate-100'
        }
      >
        {rating.toFixed(1)}
      </span>
      {count != null ? (
        <span className={inverted ? 'text-brand-100' : 'text-sky-800 dark:text-sky-400'}>
          ({count.toLocaleString()})
        </span>
      ) : null}
    </div>
  );
}

/** Stable pseudo-rating from id when review rows are not loaded yet */
export function pseudoRating(id: string): { rating: number; count: number } {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h + id.charCodeAt(i) * 31) % 997;
  const rating = Math.round((42 + (h % 50)) / 10) / 10;
  const count = 20 + (h % 1800);
  return { rating: Math.min(5, Math.max(4, rating)), count };
}
